/*
 * @Description:In User Settings Edit
 * @Author:your name
 * @Date:2019-09-26 13:40:16
 * @LastEditTime: 2021-11-29 17:18:07
 * @LastEditors: Please set LastEditors
 */
const API_BASE_FIX = '/gateway'
export default {
  getIndexDemandList: `${API_BASE_FIX}/core/no-auth/web/index/demand/list`, // 首页需求列表
  getAreaList: `${API_BASE_FIX}/demand/no-auth/list-city`, // 获取省市列表
  getDicOptionList: `${API_BASE_FIX}/demand/no-auth/dic-options`, // 科室渠道配置标
  getSearchDemandList: `${API_BASE_FIX}/core/no-auth/web/demand/search`, // 搜索
  getDemandDetail: `${API_BASE_FIX}/core/no-auth/web/demand/get`, // 卖方需求详情
  getArticleList: `${API_BASE_FIX}/product-soa/news/v1/various`,
  getArticleDetail: `${API_BASE_FIX}/product-soa/news/v1/detail`,
  getArticleSectionList: `${API_BASE_FIX}/product-soa/news/v1/sections`,
  getRecommendDemandList: `${API_BASE_FIX}/core/no-auth/web/recommend/demand/list`,
}